import { render, staticRenderFns } from "./ArrayofPagesNavigation.vue?vue&type=template&id=187ceb42"
import script from "./ArrayofPagesNavigation.vue?vue&type=script&lang=js"
export * from "./ArrayofPagesNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports